import React from 'react';
import {
  Button,
  BUTTON_VARIANTS,
  BUTTON_SIZES,
  IconArrowForward,
  IconArrowBack,
} from 'cdk-radial';
import { useSelector } from 'react-redux';
import { DAAB_ADD_LOCATIONS_STEPS } from '../../utils/daabSubscriptions';

export const StepperFooter = ({
    onNext,
    onPrevious,
    activeStep,
    steps,
    onComplete,
    selectedAPI
}) => {
  const state = useSelector((state) => state);
  const {
    subscribeRequest,
    sendingSubscribeRequest,
    dmsSupportedApis
  } = state?.daabSubscriptionsSlice;

  const {id, name, type} = selectedAPI;
  const isFirstStep = activeStep === 1;
  const isDMSStep = steps[activeStep - 1].label === DAAB_ADD_LOCATIONS_STEPS.SELECT_DMS;
  const isLastStep = activeStep === steps.length;
  const apiDMS = dmsSupportedApis[id] || [];

  const iconProps = !isLastStep
  ? {
      icon: <IconArrowForward />,
      iconSize: 24,
      isIconTrailing: true,
    }
  : {};

  const DMSFooterStyle = {
    width: '65%',
    margin: '24px auto'
  }

  const disableNextButton = () => {
    const missingCmf = Object.values(subscribeRequest).some(
      (sub) => !sub.cmfNumber
    );
    const noChange = !Object.keys(subscribeRequest).length;
    const missingDms = Object.values(subscribeRequest).some(
      (sub) => {
        if (!sub.dmsConfig || !sub.dmsConfig?.length) return true;
        const hasAllTypes = apiDMS.every((dms) =>
          sub.dmsConfig.some((config) => config.dmsType === dms)
        );
        return !hasAllTypes;
      }
    );
    if(isFirstStep && (noChange || missingCmf))
      return true
    if(isDMSStep && missingDms)
      return true
    return false;
  }
  
  return (
    <div className="daab-add-location-stepper-footer" style={isDMSStep ? DMSFooterStyle : {}}>
      {activeStep !== 1 && (
        <Button
          dataTestId="stepper-back-button"
          icon={<IconArrowBack />}
          iconSize={24}
          onClick={onPrevious}
          size={BUTTON_SIZES.STANDARD}
          text="Previous"
          variant={BUTTON_VARIANTS.SECONDARY}
        />
      )}

      <Button
        dataTestId="stepper-next-button"
        onClick={isLastStep ? onComplete : onNext}
        isDisabled={disableNextButton()}
        size={BUTTON_SIZES.STANDARD}
        text={isLastStep ? 'Complete Activation' : 'Next'}
        variant={BUTTON_VARIANTS.PRIMARY}
        isLoading={sendingSubscribeRequest}
        {...isLastStep ? {style:{width: '156px'}} : {}}
        {...iconProps}     
      />
    </div>
  );
};
